import api from './client';

export const getPlans = () => api.get('/subscriptions/plans');
export const getCurrentSubscription = () => api.get('/subscriptions/current');
export const subscribe = (data) => api.post('/subscriptions/subscribe', data);
export const upgrade = (data) => api.post('/subscriptions/upgrade', data);
export const cancelSubscription = () => api.post('/subscriptions/cancel');
